import {Component, OnInit, Output, EventEmitter, ViewChild} from '@angular/core';
import {MessageService} from 'primeng/api';
import {HttpClient} from '@angular/common/http';
import {Globals} from '../globals';

@Component({
  selector: 'app-password',
  templateUrl: './password.component.html'
})
export class PasswordComponent implements OnInit {
  @Output() showWindow = new EventEmitter<boolean>();
  @ViewChild("passwordOld") passwordOld: any;
  @ViewChild("passwordNew") passwordNew: any;

  form: any = {
    username: null,
    passwordOld: null,
    passwordNew: null,
    passwordConfirm: null
  };
  isChangeFailed = false;
  isBusy = false;
  errorMessage = '';
  user: any;

  constructor(private messageService: MessageService, private http: HttpClient, private globals: Globals) { }

  ngOnInit(): void {
  }

  onSubmit(): void {
    const { username, passwordOld, passwordNew, passwordConfirm } = this.form;
    if(passwordNew != passwordConfirm) {
      this.errorMessage = "Password confirmation doesn't match the new password!";
      this.passwordNew.valueAccessor.input.nativeElement.focus();
      this.isChangeFailed = true;
    } else {
      this.isBusy = true;
      this.isChangeFailed = false;
      this.http.get<any>(this.globals.url_root + "/auth/ResetUserPassword.action?oldPassword=" + passwordOld
                        + "&newPassword=" + passwordNew).subscribe(
        (result: any) => {
            this.isBusy  = false;
            let msgType = 'success';
            if (!result.success) {
              msgType = 'error';
              this.passwordOld.valueAccessor.input.nativeElement.focus();
            } else {
              this.showWindow.emit(false);
            }
            this.messageService.add({key: 'bc', severity:msgType, summary: 'Message', life: 3000,
              detail: result.message});
          },
          err => {
            this.isBusy = false;
            if(err.error.message) {
              this.errorMessage = err.error.message;
            }
            else if (err.error) this.errorMessage = err.error;
            this.isChangeFailed = true;
          }
        );
    }
  }

}
